'use strict';

var React = require('react');
var appTypes = require('../../types/appTypes');
var AutoSizeHelper = require('../common/AutoSizeHelper');
var CustomRect = require('../common/CustomRect');
var styleHelper = require('../../helper/styleHelper');
var textHelper = require('../../helper/util').Text;
var propConst = require('../../constants/propConst');

/*
 * 标签输入框组件
 */
var LabelTextInput = React.createClass({

  renderContent: function (text) {
    var textArr = textHelper.delimitToParagraphs(text);
    if (textArr && textArr.length) {
      return textArr.map(function (txt, index) {
        var margin = 2;
        if (index === 0) {
          margin = 0;
        }
        txt = textHelper.convertSpaceToNbsp(txt);
        return (
          <div key={index} className="paragraph">
            <p style={{marginTop: margin}}>
              {textHelper.convertSpaceToNbsp(txt)}
            </p>
          </div>
        )
      });
    }
    return null;
  },

  render: function () {
    var text = styleHelper.getText(this.props);
    var textArray = textHelper.delimitToWords(text);
    var titleText = '';
    var contentText = '';
    if (textArray.length) {
      titleText = textArray[0];
    }
    if (textArray.length > 1) {
      contentText = text.replace(titleText + ',', '');
    }
    var backgroundStyle = {};
    var borderColor = styleHelper.getBorderColor(this.props);
    var fontColor = styleHelper.getTextColor(this.props);
    var state = styleHelper.getPropertyValue(this.props, propConst.STATUS);
    styleHelper.builderTextStyle(this.props, backgroundStyle);

    if (state === appTypes.ComStatus2.DISABLE) {
      borderColor = backgroundStyle.color = '#e0e0e0';
    }
    var textColor = backgroundStyle.color;
    var titleStyle = {
      color: fontColor
    };

    var contentStyle = styleHelper.StyleUtil(this.props).text().style;
    contentStyle.color = textColor;

    styleHelper.StyleUtil(this.props, titleStyle).text();

    var labelWrapperClassName = 'contents-layout';
    if (this.props.textDirection === appTypes.TextDirection.LEFT) {
      titleText += '  ';
      labelWrapperClassName += ' label-at-left';
    } else {
      titleText = '  ' + titleText + '  ';
      labelWrapperClassName += ' label-at-right';
    }

    switch (this.props.textVAlign) {
    case 'VaTop':
      labelWrapperClassName += ' vatop';
      break;
    case 'VaBottom':
      labelWrapperClassName += ' vabottom';
      break;
    default:
      labelWrapperClassName += ' vamiddle';
      break;
    }

    return (<div className={labelWrapperClassName} style={backgroundStyle}>
      {
        this.props.textDirection === appTypes.TextDirection.LEFT
        &&
        <div ref="title" style={titleStyle} className="title">
          <label>
            {textHelper.convertSpaceToNbsp(titleText)}
          </label>
        </div>
      }
      <div className="input-rect">
        <CustomRect ref="content" {...{
          borderColor: borderColor,
          borderStyle: styleHelper.getPropertyValue(this.props, propConst.BORDER_VISIBLE) ? 'solid' : 'none',
          backgroundColor: styleHelper.getBackgroundColor(this.props)
        }} style={{overflow: 'hidden'}}>
          <div ref="context" className="content" style={contentStyle}>
            {this.renderContent(contentText)}
          </div>
        </CustomRect>
      </div>
      {
        this.props.textDirection === appTypes.TextDirection.RIGHT
        &&
        <div ref="title" className="title" style={titleStyle}>
          <label>
            {textHelper.convertSpaceToNbsp(titleText)}
          </label>
        </div>
      }
    </div>);
  }
});

module.exports = LabelTextInput;



// WEBPACK FOOTER //
// ./src/views/Components/LabelTextInput.jsx